import { Table } from "@mui/material";
import { ContentKey } from "../talentProfile/TalentDetails";
import { FormattedWorkHistory } from "./TalentWorkHistory";
import WorkHistoryTableHeaders from "./WorkHistoryTableHeaders";
import WorkHistoryTableRows from "./WorkHistoryTableRows";

type Props = {
  handleOpenEditModal: (content: ContentKey, id?: string) => void;
  data: FormattedWorkHistory[];
  handleDelete: (id: string) => void;
  canEdit?: boolean;
};

const WorkHistoryTable = ({
  handleOpenEditModal,
  data,
  handleDelete,
  canEdit = true,
}: Props) => (
  <Table sx={{ marginBottom: "0.5rem", minWidth: "500px" }}>
    <WorkHistoryTableHeaders />
    <WorkHistoryTableRows
      data={data}
      handleOpenEditModal={handleOpenEditModal}
      handleDelete={handleDelete}
      canEdit={canEdit}
    />
  </Table>
);

export default WorkHistoryTable;
